import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { useQuery } from "@redux-requests/react";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Loader } from "../../components";
import { SubmitButton, TextField } from "../../components/formik";
import { types } from "../../ducks";
import {
  createExhibitorRecording,
  deleteRecording,
  getRecording,
  updateRecording
} from "../../ducks/actions";
import useActionRequest from "../../hooks/useActionRequest";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  },
  uploaderContainer: {
    display: "flex",
    justifyContent: "center"
  },
  deleteButton: {
    color: "#FF0033",
    marginRight: "auto"
  }
}));

const RecordingDialog = ({ render, exhibitorId }) => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [id, setId] = useState(false);

  const createRecordingRequest = useActionRequest({
    action: createExhibitorRecording
  });
  const updateRecordingRequest = useActionRequest({
    action: updateRecording
  });

  const onSubmit = recording => {
    if (id) {
      updateRecordingRequest({ id, recording });
    } else {
      createRecordingRequest({ exhibitorId, recording });
    }
    setOpen(false);
  };

  const deleteRecordingRequest = useActionRequest({
    action: deleteRecording
  });

  const onDeleteRecording = () => {
    deleteRecordingRequest({ id });
    setOpen(false);
  };

  useEffect(() => {
    if (id) {
      dispatch(getRecording({ id }));
    }
  }, [id, dispatch]);

  const {
    data: { data: recording },
    recordingLoading
  } = useQuery({ type: types.GET_RECORDING, defaultData: { data: {} } });

  const onOpen = ({ id }) => {
    setOpen(true);
    setId(id);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      {render({ onOpen })}
      <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
        <Typography variant="h5" className={classes.title}>
          <strong>
            {intl.formatMessage({
              id: "Exhibitors.RecordingDialog.EditRecording",
              defaultMessage: "Edit Recording"
            })}
          </strong>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Typography>
        <Loader loading={recordingLoading}>
          <Formik
            initialValues={id ? recording : { title: "", description: "" }}
            enableReinitialize
            onSubmit={onSubmit}
          >
            <Form>
              <DialogContent>
                <TextField
                  name="videoUrl"
                  variant="outlined"
                  label={intl.formatMessage({
                    id: "Exhibitors.RecordingDialog.VideoUrl",
                    defaultMessage: "Video URL"
                  })}
                  fullWidth
                />
                <TextField
                  name="title"
                  variant="outlined"
                  label={intl.formatMessage({
                    id: "Exhibitors.RecordingDialog.Title",
                    defaultMessage: "Title"
                  })}
                  fullWidth
                />
                <TextField
                  name="description"
                  variant="outlined"
                  label={intl.formatMessage({
                    id: "Exhibitors.RecordingDialog.Description",
                    defaultMessage: "Description"
                  })}
                  multiline
                  rows={3}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                {id && (
                  <Button onClick={onDeleteRecording} className={classes.deleteButton} size="small">
                    <DeleteIcon fontSize="small" />
                    &nbsp;&nbsp;&nbsp;
                    {intl.formatMessage({
                      id: "Exhibitors.RecordingDialog.Delete",
                      defaultMessage: "Delete"
                    })}
                  </Button>
                )}
                <Button color="primary" onClick={onClose} size="small">
                  {intl.formatMessage({
                    id: "Exhibitors.RecordingDialog.Cancel",
                    defaultMessage: "Cancel"
                  })}
                </Button>
                <SubmitButton color="primary" variant="contained" size="small">
                  {intl.formatMessage({
                    id: "Exhibitors.RecordingDialog.Save",
                    defaultMessage: "Save"
                  })}
                </SubmitButton>
              </DialogActions>
            </Form>
          </Formik>
        </Loader>
      </Dialog>
    </>
  );
};

export default RecordingDialog;
